import React from "react";
import PropTypes from "prop-types";

/**
 * NeoSearch
 * Input de busca premium do NeoApp.
 * Encapsula cantos arredondados de 10px, cor de fundo creme outonal,
 * ícone de busca MDI em laranja ativo no foco, e botão de limpar integrado.
 * Estilos e animações isolados em NeoSearch.css.
 */
const NeoSearch = ({
    value = "",
    onChange,
    onClear,
    placeholder = "Buscar registros...",
    className = "",
    disabled = false,
    size = "md", // 'sm' | 'md' | 'lg'
    style = {},
    inputStyle = {},
    ...props
}) => {
    const handleClear = () => {
        if (onClear) {
            onClear();
        } else if (onChange) {
            onChange({ target: { value: "" } });
        }
    };

    const hasValue = !!value;

    return (
        <div 
            className={`neo-search-wrapper neo-search-wrapper-${size} ${className}`} 
            style={style}
        >
            {/* Lupa (Ícone de Busca) */}
            <i className="mdi mdi-magnify neo-search-magnify-icon" />

            {/* Input de Texto Nativo */}
            <input
                type="text"
                className={`form-control neo-search-input ${hasValue ? "has-clear" : ""}`}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                disabled={disabled}
                style={inputStyle}
                {...props}
            />

            {/* Botão de Limpar (Close Icon) */}
            {hasValue && (
                <i
                    className="mdi mdi-close-circle neo-search-clear-icon"
                    onClick={handleClear}
                />
            )}
        </div>
    );
};

NeoSearch.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClear: PropTypes.func,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(["sm", "md", "lg"]),
    style: PropTypes.object,
    inputStyle: PropTypes.object
};

export default NeoSearch;
